<div @click="openOverlay" class="selection-holder">
  <div class="text" :class="{ 'has-value': selectedShippingMethod }">
    <div class="label">{{ $t('shopping.basket.checkout.shipping_method') }}</div>
    <div class="value" v-if="selectedShippingMethod" v-html="selectedShippingLabel"></div>
  </div>
  <div class="icon iconfont-triangle-right"></div>
</div>

<BaseModal v-model="isModalOpen" :bottomSheetOnMobile="true">
  <template #header>{{ $t('shopping.basket.checkout.shipping_method') }}</template>
  <NBRadioGroup wrapper-class="shipping-methods-radio-group" v-model="selectedShippingMethod" @update:modelValue="handleSelect" :options="shippingMethods" valueKey="type">
    <template #default="{ option }">
      <div class="label" v-html="option.description"></div>
    </template>
  </NBRadioGroup>
</BaseModal>
